// gatsby-browser.tsx
import React from "react";
import type { GatsbyBrowser } from "gatsby";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import PageLayout from "./src/components/PageLayout";

import "./src/css/main.scss";
import "simplebar-react/dist/simplebar.min.css";

const queryClient = new QueryClient();

export const wrapRootElement = ({ element }) => (
  <QueryClientProvider client={queryClient}>{element}</QueryClientProvider>
);

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({ element, props }) => {
  return <PageLayout {...props}>{element}</PageLayout>;
};
